<template>
<aqi-panel
  :data="data"
  :aqi-level-img-path="aqiLevelImgPath"
/>
</template>

<script>
import BaseModule from './BaseModule'
import AqiPanel from './AqiPanel'
import AreaAQI from './AreaAQI'

const POLLUTANT_FILED_MAPPING = {
  'PM2.5': 'pm2p5',
  'PM10': 'pm10',
  'O3': 'o3',
  'NO2': 'no2',
  'SO2': 'so2',
  'CO': 'co'
}

export default {
  name: 'RealAqiPanel',
  extends: BaseModule,
  components: {AqiPanel},
  data () {
    return {
      data: Object.freeze(new AreaAQI(
        0,
        '--',
        new Date().getTime(),
        null,
        1,
        '--',
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      ))
    }
  },
  computed: {
    apiKey: () => 'getCurrentCityAQI',
    aqiLevelImgPath () {
      let basePath = '/static/imgs/aqi'
      let aqiLevelImgPath = []

      for (let i = 1; i <= 6; i++) {
        aqiLevelImgPath.push(`${basePath}/level-${i}.png`)
      }

      return aqiLevelImgPath
    },
    isReturn () {
      return false
    }
  },
  methods: {
    onRealDataReceived (data) {
      if (!data) {
        return
      }

      let {primary} = data
      let primaryName = null
      let primaryValue = null

      if (primary !== 'NA') {
        primaryName = AreaAQI[primary.replace('.', '')].name
        primaryValue = data[POLLUTANT_FILED_MAPPING[primary]]
      }

      let {weatherGettingCityData = {}} = data

      this.data = Object.freeze(new AreaAQI(
        data.cityId,
        data.cityName,
        data.dataTime,
        data.aqi,
        data.level,
        data.category,
        primaryName,
        primaryValue,
        data.pm2p5,
        data.pm10,
        data.o3,
        data.no2,
        data.so2,
        data.co,
        weatherGettingCityData.windScale,
        weatherGettingCityData.wind360,
        weatherGettingCityData.temp,
        weatherGettingCityData.humidity,
        weatherGettingCityData.pressure
      ))
    }
  }
}
</script>

<style lang="scss" scoped>
.aqi-panel {
  --aqi-panel-height: auto;
  /*--aqi-panel-bg: linear-gradient(22deg, rgb(61, 231, 255, .4), rgba(33, 123, 244, .4));*/
  --aqi-panel-bg: rgba(0, 21, 62, .5);
}
</style>



// WEBPACK FOOTER //
// src/views/01Data-Overview/RealAqiPanel.vue